<template>
  <div class="mt-2">
    <b-spinner v-if="loadingCircle" class="text-center text-danger my-2 align-middle"></b-spinner>
    <strong v-if="loadingText" class="ml-2">Chargement ... ({{ progress }}/{{ max }})</strong>
    <strong v-if="loadingTextPercentage" class="ml-2">Chargement ... ({{ progressPercentage.toFixed(0) }}%)</strong>
    <b-progress v-if="progressBar" :value="progress" :max="max" show-value animated variant="danger"></b-progress>
    <i v-if="showDisplayValue" class="text-center">{{ displayValue }}</i>
  </div>
</template>

<script>
  export default {
    name: 'Loading',
    props: {
      max: {
        type: Number,
        default: 0
      },
      progress: {
        type: Number,
        default: 0
      },
      displayValue: {
        type: String,
        default: ''
      },
      loadingCircle: {
        type: Boolean,
        default: false
      },
      loadingText: {
        type: Boolean,
        default: false
      },
      loadingTextPercentage: {
        type: Boolean,
        default: false
      },
      progressBar: {
        type: Boolean,
        default: false
      },
      showDisplayValue: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      progressPercentage() {
        return this.progress/this.max*100;
      }
    }
  }
</script>

<style scoped>

</style>